<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-8">
      <h2 class="">{{ $t("navigations.analytical dashboards") }}</h2>
    </div>
    <div class="col-lg-4">
      <div class="title-action">
      </div>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <ul class="nav nav-tabs col-lg-12 mb-1" role="tablist">
        <li>
          <a href="#tab-1" class="nav-link" :class="{ activeTab: refreshFlags['DataAnalytics'] === true }"
            data-toggle="tab" @click="handleTabClick('DataAnalytics')">
            {{ $t("navigations.clinical trial data analytics") }}
          </a>
        </li>
        <li v-if="rollsprivilages.includes('Analytical Dashboards Operational Analytics')">
          <a href="#tab-2" class="nav-link" :class="{
            activeTab: refreshFlags['OperationalAnalytics'] === true,
          }" data-toggle="tab" @click="handleTabClick('OperationalAnalytics')">
            {{ $t("navigations.operational analytics") }}</a>
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="row" v-if="refreshFlags['DataAnalytics']">
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Demographics Summary')">
                  <router-link to="/demographicReport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge dm-color align-middle mr-1">{{ $t("navigations.de") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center mt-1">
                          <h4 class="font-bold">{{ $t("navigations.demographics summary") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.interactive dashboard overview") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Adverse Events Summary')">
                  <router-link to="/aereport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.ae") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center mt-1">
                          <h4 class="font-bold">{{ $t("navigations.adverse events summary") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.critical insights: adverse events dashboard") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Subject Status Report')">
                  <router-link to="/subjectstatusreport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ss-color align-middle mr-1">{{ $t("navigations.ss") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.subject status report") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.mortality analysis: summary report") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Death Summary Report')">
                  <router-link to="/deathsummaryreport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ds-color align-middle mr-1">{{ $t("navigations.ds") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center mt-1">
                          <h4 class="font-bold">{{ $t("navigations.death summary report") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.mortality analysis: summary report") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Lab Summary Report')">
                  <router-link to="/labsummaryreport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge lb-color align-middle mr-1">{{ $t("navigations.ls") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.lab summary report") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.laboratory findings: summary report") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Lab Result Review Overtime')">
                  <router-link to="/labresultreview">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge lb-color align-middle mr-1">{{ $t("navigations.ls") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.lab result review overtime") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.trend analysis: lab results over time") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Lab Descriptive Status')">
                  <router-link to="/labdescriptivestatus">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge lb-color align-middle mr-1">{{ $t("navigations.ls") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.lab descriptive status") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.lab descriptive status") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Vital Sign Result Trends')">
                  <router-link to="/vitalsignreport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge vs-color align-middle mr-1">{{ $t("navigations.vs") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.vital sign result trends") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.health monitoring: vital signs trends") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Vital Signs Descriptive Status')">
                  <router-link to="/vitalsigndescriptivestats">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge vs-color align-middle mr-1">{{ $t("navigations.vs") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.vital signs descriptive status") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.vital signs descriptive status") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Medical History Summary')">
                  <router-link to="/medicalhistory">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge mh-color align-middle mr-1">{{ $t("navigations.mh") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.medical history summary") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.mortality analysis: summary report") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Medical History Cross Tabulation')">
                  <router-link to="/medicalhistorycrosstab">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge mh-color align-middle mr-1">{{ $t("navigations.mh") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.medical history cross tabulation") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.medical history cross tabulation") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Adverse Events Cross Tabulation')">
                  <router-link to="/advereventcrosstabulation">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.ae") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">
                            {{ $t("navigations.adverse events cross tabulation") }}
                          </h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.event correlations: ae cross tabulation") }}
                              </small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Lab Result Trends')">
                  <router-link to="/labResultTrend">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge lb-color align-middle mr-1">{{ $t("navigations.lt") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.lab result trends") }} </h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.lab result trends") }} </small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Treatment Emergent AE')">
                  <router-link to="/treatmentEmergentAE">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.te") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">
                            {{ $t("navigations.treatment emergent ae") }}
                          </h4>
                          <span>
                            <h4>
                              <small> {{ $t("navigations.treatment emergent ae") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Adverse Events Overlay Labs')">
                  <router-link to="/ae_OverlayLabsReport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.ao") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.adverse events overlay labs") }} </h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.adverse events overlay labs") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>

                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Vital Signs Result Overtime')">
                  <router-link to="/vitalsignsresultovertime">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.vs") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.vital signs result overtime") }} </h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.vital signs result overtime") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards AE Incidence Table')">
                  <router-link to="/aeincidencetable">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.ae") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.ae incidence table") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.ae incidence table") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Exposure Data Report')">
                  <router-link to="/exposurereport">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.er") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.exposure data report") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.exposure data report") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-md-4 pl-0 mb-2"
                  v-if="rollsprivilages.includes('Analytical Dashboards Exposure And Adverse Events')">
                  <router-link to="/exposureandadverseevents">
                    <div class="ip-widget">
                      <div class="row">
                        <div class="col-2 justify-content-center align-self-center pl-1 py-0 pr-0 mt-1">
                          <span class="ip-badge ae-color align-middle mr-1">{{ $t("navigations.ea") }}</span>
                        </div>
                        <div class="col-10 text-left justify-content-center align-self-center">
                          <h4 class="font-bold">{{ $t("navigations.exposure and adverse events") }}</h4>
                          <span>
                            <h4>
                              <small>{{ $t("navigations.exposure and adverse events") }}</small>
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-md-3 dash-widget">
              <h4>{{ $t("navigations.insights portal") }}</h4>
              <div>
                <ul class="list-group">
                  <router-link to="/demographicReport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Demographics Summary')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side dm-color align-middle mr-1">{{ $t("navigations.de") }}</span>
                      <span> {{ $t("navigations.demographics") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/aereport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Adverse Events Summary')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.ae") }}</span>
                      <span>{{ $t("navigations.adverse events summary") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/subjectstatusreport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Subject Status Report')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ss-color align-middle mr-1">{{ $t("navigations.ss") }}</span>
                      <span>{{ $t("navigations.subject status report") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/deathsummaryreport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Death Summary Report')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ds-color align-middle mr-1">{{ $t("navigations.ds") }}</span>
                      <span>{{ $t("navigations.death summary report") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/labsummaryreport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Lab Summary Report')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side lb-color align-middle mr-1">{{ $t("navigations.ls") }}</span>
                      <span>{{ $t("navigations.lab summary report") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/labresultreview"
                    v-if="rollsprivilages.includes('Analytical Dashboards Lab Result Review Overtime')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side lb-color align-middle mr-1">{{ $t("navigations.ls") }}</span>
                      <span>{{ $t("navigations.lab result review overtime") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/labdescriptivestatus"
                    v-if="rollsprivilages.includes('Analytical Dashboards Lab Descriptive Status')">
                    <li class="ip-list-item d-flex ip-text mb-1 p-1">
                      <span class="ip-badge-side lb-color align-middle mr-1">{{ $t("navigations.ls") }}</span>
                      <span>{{ $t("navigations.lab descriptive status") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/vitalsignreport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Vital Sign Result Trends')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side vs-color align-middle mr-1">{{ $t("navigations.vs") }}</span>
                      <span>{{ $t("navigations.vital sign result trends") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/vitalsigndescriptivestats"
                    v-if="rollsprivilages.includes('Analytical Dashboards Vital Signs Descriptive Status')">
                    <li class="ip-list-item d-flex ip-text mb-1 p-1">
                      <span class="ip-badge-side vs-color align-middle mr-1">{{ $t("navigations.vs") }}</span>
                      <span>{{ $t("navigations.vital sign descriptive status") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/medicalhistory"
                    v-if="rollsprivilages.includes('Analytical Dashboards Medical History Summary')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side mh-color align-middle mr-1">{{ $t("navigations.mh") }}</span>
                      <span>{{ $t("navigations.medical history summary") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/medicalhistorycrosstab"
                    v-if="rollsprivilages.includes('Analytical Dashboards Medical History Cross Tabulation')">
                    <li class="ip-list-item d-flex ip-text mb-1 p-1">
                      <span class="ip-badge-side mh-color align-middle mr-1"> {{ $t("navigations.mh") }}</span>
                      <span>{{ $t("navigations.medical history cross tabulation") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/advereventcrosstabulation"
                    v-if="rollsprivilages.includes('Analytical Dashboards Adverse Events Cross Tabulation')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1"> {{ $t("navigations.ae") }}</span>
                      <span class="text-wrap">{{ $t("navigations.adverse events cross tabulation") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/labResultTrend"
                    v-if="rollsprivilages.includes('Analytical Dashboards Lab Result Trends')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1"> {{ $t("navigations.lr") }}</span>
                      <span class="text-wrap">{{ $t("navigations.lab result trends") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/treatmentEmergentAE"
                    v-if="rollsprivilages.includes('Analytical Dashboards Treatment Emergent AE')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.ae") }}</span>
                      <span class="text-wrap">{{ $t("navigations.treatment emergent ae") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/ae_OverlayLabsReport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Adverse Events Overlay Labs')">
                    <li class="ip-list-item d-flex ip-text mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.ao") }}</span>
                      <span class="text-wrap">{{ $t("navigations.adverse events overlay labs") }} </span>
                    </li>
                  </router-link>
                  <router-link to="/vitalsignsresultovertime"
                    v-if="rollsprivilages.includes('Analytical Dashboards Vital Signs Result Overtime')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.vs") }}</span>
                      <span class="text-wrap">{{ $t("navigations.vital signs result overtime") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/aeincidencetable"
                    v-if="rollsprivilages.includes('Analytical Dashboards AE Incidence Table')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.ae") }}</span>
                      <span class="text-wrap">{{ $t("navigations.ae incidence table") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/priorconcomitantsummary"
                    v-if="rollsprivilages.includes('Analytical Dashboards Prior and Concomitant Treatment Summary')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">PC{{ $t("navigations.pc") }}</span>
                      <span class="text-wrap">{{ $t("navigations.prior and concomitant treatment summary") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/comparativelabresult"
                    v-if="rollsprivilages.includes('Analytical Dashboards Comparative Lab Results')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.cl") }}</span>
                      <span class="text-wrap">{{ $t("navigations.comparative lab results") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/exposurereport"
                    v-if="rollsprivilages.includes('Analytical Dashboards Exposure Data Report')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">ER</span>
                      <span class="text-wrap">{{ $t("navigations.exposure data report") }}</span>
                    </li>
                  </router-link>
                  <router-link to="/exposureandadverseevents"
                    v-if="rollsprivilages.includes('Analytical Dashboards Exposure And Adverse Events')">
                    <li class="ip-list-item d-flex ip-text align-items-center mb-1 p-1">
                      <span class="ip-badge-side ae-color align-middle mr-1">{{ $t("navigations.ea") }}</span>
                      <span class="text-wrap">{{ $t("navigations.exposure and adverse events") }}</span>
                    </li>
                  </router-link>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./Analytical_Dashboards"></script>
<style scoped>
.activeTab {
  color: #495057;
  background-color: #fff !important;
  border-color: #dee2e6 #dee2e6 #ffffff00;
}
</style>